import { render, staticRenderFns } from "./OfferLandingPage.vue?vue&type=template&id=85e4ab82&scoped=true&"
import script from "./OfferLandingPage.vue?vue&type=script&lang=js&"
export * from "./OfferLandingPage.vue?vue&type=script&lang=js&"
import style0 from "./OfferLandingPage.vue?vue&type=style&index=0&id=85e4ab82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e4ab82",
  null
  
)

export default component.exports